<template>
	<div :class="$route.name === 'personal' ? 'material-content-list personal-collect-material':'material-content-list'" >
		<ul>
			<li v-for="(item,index) in formData" :key="index" @click="handleOpenDetail(item)">
				<el-image
					class="thumb"
					:src="item.thumb_url ? item.thumb_url:item.material_thumb"
					fit="cover"></el-image>
				<p class="material-item-title lg-list-title">{{item.title ? item.title:item.material_title}}</p>
				<p class="material-item-info" v-if="!item.is_download"><span class="lg-text-ell lg-list-item">{{item.category}}</span><span class="lg-text-ell lg-list-item">{{item.view_count}}人浏览</span></p>
				<p class="material-item-info" v-else><span class="lg-text-ell lg-list-item">{{item.category ? item.category : item.material_category}}</span><span class="lg-text-ell lg-list-item">已下载</span></p>
				<div class="material-item-price">
					<p v-if="(item.price && item.price !== 0) || (item.material_price && item.material_price !== 0)" style="display: flex;align-items: center"><img class="price" src="../assets/img/icon-money.png" alt=""><span style="color: #f88117" class="lg-f12">{{item.price ? item.price:item.material_price}}</span></p>
					<p v-else style="color: #f88117" class="lg-f12">免费</p>
					<p v-if="item.publish === 3" @click.stop="handleCloseMaterialCollect(item,index)"><img :src="item.is_collect ? require('../assets/img/icon-collect_active.png'):require('../assets/img/icon-collect.png')" alt=""> <span class="lg-list-item">收藏</span></p>
					<p v-else class="lg-list-item">{{item.publish_info}}</p>
				</div>
				<div class="material-mask" v-if="$route.name === 'personal' && $route.query.name ==='material'">
					<p @click.stop="handleDeleteMaterial(item.id,index)"><img src="../assets/img/personal/icon-delete.png" alt="">删除</p>
					<p @click.stop="$router.push({query:{name:'created',id:item.id}})"><img src="../assets/img/personal/icon-white-edit.png" alt="">编辑</p>
				</div>
				<div class="material-rate-mask" v-if="($route.name === 'personal' && $route.query.name ==='down')">
					<p @click.stop="handleRateMaterial(item)"><img src="../assets/img/personal/icon-white-edit.png" alt="">评分</p>
				</div>
				<div class="rec" v-if="item.is_rec === 1">推荐</div>
			</li>
		</ul>
	</div>
</template>

<script>
  export default {
    name: "material",
    props:['formData'],
    data() {
      return {}
    },
    methods: {
      handleCloseMaterialCollect(data,index){
        const status = this.$utils.loginStatus()
        if (status) {
          data. is_collect= !data.is_collect
          this.$requestApi.index.getUserCollect({
            type: "material",
            source_id: this.$route.query.name && this.$route.query.name === 'down'? data.material_id: data.id
          }).then(res =>  {
            if (!data.is_collect){
              this.$Bus.$emit('closeMaterialCollect',index)
            }
          })
        }
      },
      // 素材删除
      handleDeleteMaterial(id,index){
        let info = {
          id:id,
          index:index
        }
        this.$Bus.$emit('deleteMaterial',info)
      },
      // 素材评分
      handleRateMaterial(data){this.$Bus.$emit('rateMaterial',data)},
      // 素材详情
      handleOpenDetail(data){
        const {href} = this.$router.resolve({
          name: data.material_type && data.material_type == 1 ? 'work_detail':'material_detail',
          query: {
            id:this.$route.name === 'personal' && this.$route.query.name === 'down'?data.material_id:data.id
          }
        })
        window.open(href, '_blank')
      }
    }
  }
</script>

<style scoped lang='less'>
	.material-content-list{
		position: relative;
		margin-top: 25px;
		/*margin-right: -20px;*/
		ul{
			display: flex;
			flex-wrap: wrap;
		}
		li{
			width:265px;
			border-radius: 6px;
			margin-right: 28px;
			margin-bottom: 28px;
			padding-bottom: 6px;
			position: relative;
			cursor: pointer;
			transition: all .3s;
			background-color: #ffffff;
			.thumb{
				width: 100%;
				height: 152px;
				border-radius: 8px 8px 0 0;
				margin-bottom: 8px;
			}
			.rec{
				padding:2px 10px;
				background: linear-gradient(0deg, #F2CA5B 0%, #FFE6A3 100%);
				border-radius: 0 6px 0 4px;
				position: absolute;
				right: 0;
				top: 0;
				font-size: 12px;
				color: #663D00;
				font-weight: bold;
			}
			.material-item-title{
				max-width: 90%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				padding: 0 8px;
				margin-bottom: 8px;
			}
			.material-item-info{
				padding: 0 8px;
				margin-bottom: 8px;
				display: flex;
				align-items: center;
				span:first-child{
					max-width: 120px;
					display: inline-block;
				}
				span:last-child:before{
					content: "·";
					color: #8d92a1;
					font-size: 12px;
					margin: 0 5px;
				}
			}
			.material-item-price{
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 8px;
				img{
					display: inline-block;
					width: 14px;
					height: 15px;
					margin-right:7px;
				}
				p:last-child{
					display: flex;
					align-items: center;
					height: 14px;
					white-space: nowrap;
					img{
						width: 14px;
						height: 14px;
						display: inline-block;
						margin-bottom: 0;
						margin-right: 5px;
					}
				}
			}
			.material-item-user{
				padding: 0 8px;
				display: flex;
				justify-content: space-between;
				span{
					font-size: 12px;
					color: #666666;
				}
			}
		}
		li:hover{
			transform: translateY(-2px);
			box-shadow: 0 12px 20px 0 rgba(95,101,105,.15);
			.material-mask{
				cursor: pointer;
				visibility:visible;
				height: 152px;
			}
			.material-rate-mask{
				cursor: pointer;
				visibility:visible;
				height: 152px;
			}
		}
		li:nth-child(5n){
			margin-right: 0;
		}
		.material-mask{
			width: 100%;
			height: 0;
			background-color: rgba(0, 0, 0, 0.6);
			position: absolute;
			top: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 6px 6px 0 0;
			visibility: hidden;
			transition: all 0.2s linear;
			p{
				float: left;
				color: #ffffff;
				font-size: 12px;
				padding: 7px;
				margin-right: 10px;
				img{
					width: 18px;
					height: 18px;
					display: inline-block;
					vertical-align: middle;
					position: relative;
					bottom: 1px;
					margin-right: 5px;
				}
			}
		}
		.material-rate-mask{
			width: 100%;
			height: 0;
			background-color: rgba(0, 0, 0, 0.6);
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 0;
			border-radius: 6px 6px 0 0;
			visibility: hidden;
			transition: all 0.2s linear;
			p{
				color: #ffffff;
				font-size: 12px;
				img{
					width: 18px;
					height: 18px;
					display: inline-block;
					vertical-align: middle;
					position: relative;
					bottom: 1px;
					margin-right: 5px;
				}
			}
		}
	}
	.personal-collect-material{
		margin-top: 0;
		li{
			width: 232px;
			margin-right:14px !important;
			margin-bottom: 14px !important;
		}
		li:nth-child(5n){
			margin-right: 0 !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/material.vue